<!-- 服务 -->
<template>
  <div class="page">
    <!-- 横幅 -->
    <Banner></Banner>
    <!-- 服务生态 -->
    <ServiceEcosystem></ServiceEcosystem>
    <!-- 服务体系 -->
    <ServiceSystem></ServiceSystem>
  </div>
</template>

<script>
import Banner from "./components/Banner.vue";
import ServiceEcosystem from "./components/ServiceEcosystem.vue";
import ServiceSystem from "./components/ServiceSystem.vue";

export default {
  components: {
    Banner,
    ServiceEcosystem,
    ServiceSystem
  }
};
</script>

<style lang="less" scoped>
</style>
